import Payment from 'payment';

function clearNumber(value = '') {
    return value.replace(/\D+/g, '');
}

///////////////////////////////////////////
// Credit card numbers for testing
/*

Visa                4111 1111 4555 1142
Visa Debit          4002 6900 0000 0008
Mastercard          5555 4444 3333 1111
Mastercard Debit    2223 5204 4356 0010
American Express    3714 4963 5398 431
Diners Club         3056 9309 0259 04
Discover            6011 1111 1111 1117

--- DISABLED:
Visa Electron       4917300800000000
Maestro             5000 5500 0000 0029
JCB                 3569 9900 1009 5841
Hipercard           6062 8288 8866 6688
UnionPay            6243 0300 0000 0001
Elo                 5066 9911 1111 1118

*/
export function formatCreditCardNumber(value) {
    if (!value) {
        return value;
    }

    const issuer = Payment.fns.cardType(value);
    const clearValue = clearNumber(value);
    let nextValue;

    switch (issuer) {
        case 'amex':
            nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(4, 10)} ${clearValue.slice(10, 15)}`;
            break;
        case 'dinersclub':
            nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(4, 10)} ${clearValue.slice(10, 14)}`;
            break;
        default:
            nextValue = `${clearValue.slice(0, 4)} ${clearValue.slice(4, 8)} ${clearValue.slice(
                8,
                12
            )} ${clearValue.slice(12, 19)}`;
            break;
    }

    return nextValue.trim();
}

export function formatCVC(value, cardNumber) {
    const clearValue = clearNumber(value);
    let maxLength = 4;

    const issuer = Payment.fns.cardType(cardNumber);
    maxLength = issuer === 'amex' ? 4 : 3;

    return clearValue.slice(0, maxLength);
}

export function formatExpirationDate(prevValue, value) {
    const clearValue = clearNumber(value);

    if (clearValue.length === 2) {
        const month = Number(clearValue);
        if (!(month >= 1 && month <= 12)) {
            return prevValue;
        }
    }

    if (clearValue.length === 4) {
        const year = Number(clearValue.slice(2, 4));
        const currYear = new Date().getFullYear() - 2000;
        if (year < currYear || year > currYear + 15) {
            return prevValue;
        }
    }

    if (clearValue.length >= 3) {
        return `${clearValue.slice(0, 2)}/${clearValue.slice(2, 4)}`;
    }

    return clearValue;
}
